import styles from './NCDealHuntSlider.module.css'
import styleUtils from 'shared-components/styles/util.module.css'
import { DSNCDealHuntSlider } from 'shared-definitions/types'
import { DealhuntSliderWidget, getAnalytics } from '@authority-media/dealhunt-widgets/slider'
import clsx from 'clsx'
import { ThemeContext } from '../contexts/ThemeContext'

interface NCDealHuntSliderProps {
  data: DSNCDealHuntSlider
}

const analytics = getAnalytics()

const NCDealHuntSlider: React.FC<NCDealHuntSliderProps> = ({ data }) => {
  const { theme } = ThemeContext.useContainer()

  return (
    <div data-container-type="content" className={clsx(styleUtils.nc, styles.container)}>
      <DealhuntSliderWidget
        theme={theme}
        onEvent={analytics.trackEvent}
        source={data.source}
        templateId={data.templateId}
        maxItems={data.maxItems}
        minScore={data.minScore}
        placement={data.placement}
        site={data.site}
      />
    </div>
  )
}

export default NCDealHuntSlider
